class ProductListCategory extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(this).css({"opacity":"1"});

      var swiper = new Swiper(".productcategoryslider", {
      slidesPerView:3.5,
      spaceBetween:25,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
          320: {
            slidesPerView:3.5,
            spaceBetween: 20
          },
          480: {
            slidesPerView:3.5,
            spaceBetween: 25
          },
          640: {
            slidesPerView:4.5,
            spaceBetween: 25
          },
         990: {
            slidesPerView:6.5,
            spaceBetween: 25
         },
         1024: {
           slidesPerView:8.5,
           spaceBetween: 25
         },
        1200: {
          slidesPerView:10.5,
          spaceBetween: 30
         },
        1441:{
          slidesPerView:11.5,
          spaceBetween: 35
        }
      },
    });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("product-list-category", ProductListCategory);